import React from 'react';





const FinancialStatus = () => {
    const total = 10000000;

    return (
        <div className="card-inner d-flex flex-column h-100">
            <div className="card-title-group pb-1 g-2 chart-title-bg">
                <div className="card-title me-1">
                    <h6 className="title">وضعیت مالی</h6>
                    <p>در دوره جاری وضعیت مالی با توجه به اسناد ثبت شده به صورت زیر میباشد</p>
                </div>
                <div className="card-tools mt-n1 me-n1">
                    <div className="dropdown">
                        <a href="#" className="dropdown-toggle dropdown-indicator btn btn-sm btn-outline-light btn-white" data-bs-toggle="dropdown">۳۰ روز</a>
                        <div className="dropdown-menu dropdown-menu-end dropdown-menu-xs">
                            <ul className="link-list-opt no-bdr">
                                <li><a href="#"><span>۷ روز</span></a></li>
                                <li><a href="#"><span>۱۵ روز</span></a></li>
                                <li><a href="#"><span>۳۰ روز</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="progress-list  gy-3 mt-2">
                <div className="progress-wrap">
                    <div className="progress-text">
                        <div className="progress-label">دارایی‌ها</div>
                        <div className="progress-amount">۵,۸۰۰,۰۰۰ ریال</div>
                    </div>
                    <div className="progress progress-md ">
                        <div className="progress-bar " data-progress="58" style={{ width: `${(5800000 / total) * 100}%` }}></div>
                    </div>
                </div>
                <div className="progress-wrap">
                    <div className="progress-text">
                        <div className="progress-label">بدهی‌ها</div>
                        <div className="progress-amount">۲,۴۰۰,۰۰۰ ریال</div>
                    </div>
                    <div className="progress progress-md">
                        <div className="progress-bar bg-warning" data-progress="24" style={{ width: `${(2400000 / total) * 100}%` }}></div>
                    </div>
                </div>
                <div className="progress-wrap">
                    <div className="progress-text">
                        <div className="progress-label">حقوق صاحبان سهام </div>
                        <div className="progress-amount">3,4۰۰,۰۰۰ ریال</div>
                    </div>
                    <div className="progress progress-md">
                        <div className="progress-bar bg-azure" data-progress="100" style={{ width: `${(3400000 / total) * 100}%` }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinancialStatus;
